import greenEditorIcon from './../assets/editorIcons/greenEditorIcon.svg';
import lifeEditorIcon from './../assets/editorIcons/lifeEditorIcon.svg';
import artEditorIcon from './../assets/editorIcons/artEditorIcon.svg';
import sportEditorIcon from './../assets/editorIcons/sportEditorIcon.svg';
import lightsEditorIcon from './../assets/editorIcons/lightsEditorIcon.svg';
import extrasEditorIcon from './../assets/editorIcons/extrasEditorIcon.svg';
import furnitureEditorIcon from './../assets/editorIcons/furnitureEditorIcon.svg';
import christmasEditorIcon from './../assets/editorIcons/christmasEditorIcon.svg';

export const categoryIcon = (categoryName) => {
    switch (categoryName) {
      case "green":
        return <img src={greenEditorIcon} alt="green" />;

      case "life":
        return <img src={lifeEditorIcon} alt="life" />;

      case "art":
        return <img src={artEditorIcon} alt="art" />;


      case "extras":
        return <img src={extrasEditorIcon} alt="extras" />;

      case "light":
        return <img src={lightsEditorIcon} alt="light" />;

      case "sport":
        return <img src={sportEditorIcon} alt="sport" />;

      case "furniture":
        return <img src={furnitureEditorIcon} alt="furniture" />;

      case "Christmas":
        return <img src={christmasEditorIcon} alt="christmas" />;

      default:
        return (
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "2rem", color: "#009245" }}
          >
            eco
          </span>
        );
    }
  };